document.addEventListener("DOMContentLoaded", () => {
    var parent_product_name = document.querySelector("#parent_product_name").value;
    var related_variants = document.querySelectorAll(".product-options .related-variant-title");
    var saved_parent_name = localStorage.getItem("parent_name");
    var saved_material = localStorage.getItem("Materiał");
    var saved_color = localStorage.getItem("Kolor");
    var saved_rozmiar = localStorage.getItem("Rozmiar");
    var existing_title = false;
    related_variants.forEach(item => {
        if(saved_parent_name == item.innerHTML){
            existing_title = true;
            return;
        }
    })

    function updateVariantDimensions(variantId) {
      const data = variantDimensions[variantId];
      if (!data) return;
      const el = (selector) => document.querySelector(selector);
      if (el('.product_detail_sku_width')) el('.product_detail_sku_width').textContent = data.width + ' cm';
      if (el('.product_detail_sku_depth')) el('.product_detail_sku_depth').textContent = data.depth + ' cm';
      if (el('.product_detail_sku_height')) el('.product_detail_sku_height').textContent = data.height + ' cm';
      if (el('.product_detail_sku_sleeping_width')) el('.product_detail_sku_sleeping_width').textContent = data.sleeping_width + ' cm';
      if (el('.product_detail_sku_sleeping_length')) el('.product_detail_sku_sleeping_length').textContent = data.sleeping_length + ' cm';
    }

    function updateSku() {
        const selectedVariantId = Number(document.querySelector('[name="id"]').value);

        const selectedVariant = productVariants.find(variant => {
            return variant.id === selectedVariantId;
        });

        if (selectedVariant) {
            document.querySelector(".product_detail_sku").innerHTML =
                selectedVariant.sku;
        }
    }
    
    function updateInstallmentPrice() {
        const variantInput = document.querySelector('[name="id"]');
        const installmentElement = document.querySelector('[data-installment-value]');

        if (!variantInput || !installmentElement) return;

        const selectedVariantId = Number(variantInput.value);

        const selectedVariant = productVariants.find(variant => {
            return Number(variant.id) === selectedVariantId;
        });

        if (selectedVariant) {
            const installment = selectedVariant.price / 3 / 100;

            installmentElement.textContent = installment.toLocaleString('pl-PL', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }) + ' zł';
        }
    }

    var combine_items = document.querySelectorAll(".combine-item-colors .combine-color-item");
    if(combine_items.length > 0){
        combine_items.forEach(item => {
            var material = item.dataset.material;
            var color = item.dataset.color;
            var colorCode = item.dataset.colorCode;
            item.addEventListener("click", () => {
                var active_item = document.querySelector(".combine-item-colors .combine-color-item.combine-color-item-active");
                if(active_item){
                    active_item.classList.remove("combine-color-item-active");
                }
                document.querySelector(`input[value="${material}"]`).checked = true;
                document.querySelector(`label[data-value="${color}"]`).click();
                document.querySelector(".material_value").innerHTML = material;
                document.querySelector(".color_value").innerHTML = color;
                const colorCodeEl = document.querySelector(".color_code_value");
                if (colorCodeEl) {
                    colorCodeEl.innerHTML = colorCode;
                }
                item.classList.add("combine-color-item-active");
                var active_color_index = document.querySelector(`.product-detail-color-item[data-label="${color}"]`).dataset.index;
                new_swiper2.slideTo(active_color_index);
                document.querySelector(".each_product_option .product_detail_Materiał").innerHTML = material; 
                document.querySelector(".each_product_option .product_detail_Kolor").innerHTML = color;
                // document.querySelector(".each_product_option .product_detail_sku").innerHTML = document.querySelector(".product-sku.js-product-sku").innerHTML;
                setTimeout(() => {
                    updateSku();
                    updateInstallmentPrice();
                }, 50);
                const selectedVariantId = document.querySelector('[name="id"]').value;
                updateVariantDimensions(selectedVariantId);
                localStorage.setItem("Materiał", material);
                localStorage.setItem("Kolor", color);
            })
        });
    }
    var size_mini_icons = document.querySelectorAll(".product_size_content .product_size_mini_icon");
    if(size_mini_icons.length > 0){
        size_mini_icons.forEach(item => {
            var size_option_name = item.dataset.label;
            item.addEventListener("click", ()=> {
                var active_size_icon = document.querySelector(".product_size_content .product_size_mini_icon.product_size_active");
                if(active_size_icon){
                    active_size_icon.classList.remove("product_size_active");
                }
                document.querySelector(`label[data-value="${size_option_name}"]`).click();
                document.querySelector(".product_size_option .selected_size_option").innerHTML = size_option_name;
                item.classList.add("product_size_active");
                if(document.querySelector(`.each_product_option .product_detail_${item.dataset.option}`)){
                    document.querySelector(`.each_product_option .product_detail_${item.dataset.option}`).innerHTML = size_option_name;
                }
                // document.querySelector(".each_product_option .product_detail_sku").innerHTML = document.querySelector(".product-sku.js-product-sku").innerHTML;
                setTimeout(() => {
                    updateSku();
                    updateInstallmentPrice();
                }, 50);
                const selectedVariantId = document.querySelector('[name="id"]').value;
                updateVariantDimensions(selectedVariantId);
                localStorage.setItem("Rozmiar", size_option_name);
            })
        })
    }
    if(existing_title){
        if(saved_material && saved_color){
            document.querySelectorAll(`.combine-color-item[data-color="${saved_color}"]`).forEach(item => {
                if(item.dataset.material == saved_material){
                    item.click();
                }
            })
        }else {
            saved_material = document.querySelector('input[data-option="Materiał"]:checked').value;
            localStorage.setItem("Materiał", saved_material);
            saved_color = document.querySelector('input[data-option="Kolor"]:checked').value;
            localStorage.setItem("Kolor", saved_color);
        }
        if(saved_rozmiar){
            document.querySelector(`.product_size_mini_icon[data-label="${saved_rozmiar}"]`).click();
        }else {
            saved_rozmiar = document.querySelector('input[data-option="Rozmiar"]:checked').value;
            localStorage.setItem("Rozmiar", saved_rozmiar);
        }
    }else {
        localStorage.setItem("parent_name", parent_product_name);
        saved_material = document.querySelector('input[data-option="Materiał"]:checked').value;
        localStorage.setItem("Materiał", saved_material);
        saved_color = document.querySelector('input[data-option="Kolor"]:checked').value;
        localStorage.setItem("Kolor", saved_color);
        saved_rozmiar = document.querySelector('input[data-option="Rozmiar"]:checked')?.value;
        localStorage.setItem("Rozmiar", saved_rozmiar);
    }
    // var product_option_not_hidden = document.querySelector(".product-options .product-options__default.option_not_hidden");
    // if(product_option_not_hidden){
    //     console.log(product_option_not_hidden);
    //     product_option_not_hidden.querySelectorAll(".radio-option label").forEach(item => {
    //         item.addEventListener("click", () => {
    //             var option_name = item.dataset.option;
    //             document.querySelector(`.each_product_option .product_detail_${option_name}`).innerHTML = item.dataset.value;
    //         })
    //     })
    // }
    // Aktualizacja raty po załadowaniu strony
    updateInstallmentPrice();
  
})


// document.querySelectorAll(".majki-collapse").forEach((item) => {
// 	const button = item.querySelector(".majki-collapse__trigger");
// 	const icon = item.querySelector(".majki-collapse__icon");

// 	if (!button) return;

// 	button.addEventListener("click", () => {
// 		const isOpen = item.classList.contains("is-open");

// 		item.classList.toggle("is-open");

// 		// if (icon) {
// 		// 	icon.textContent = isOpen ? "+" : "−";
// 		// }
// 	});
// });

document.querySelectorAll(".majki-collapse").forEach((item) => {
  const button = item.querySelector(".majki-collapse__trigger");

  if (!button) return;

  button.addEventListener("click", () => {
    item.classList.toggle("is-open");
  });
});